module.exports = __webpack_public_path__ + "static/media/icon_star_blue.0c09fe55.svg";